import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { shape, string, bool } from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import adManagementSettingsSelectors from 'store/ad-management-settings/selectors';
import AdManagementCommonBar from 'views/molecules/commonbar/components/AdManagementCommonBar';
import { masterDataActions } from 'store/master-data';
import adManagementSelectors from 'store/ad-management/selectors';

function AdManagementCommonBarContainer(props) {
  const { title, tooltip, allowedScreen } = props;

  const [
      filters,
      mode,
    ] = [
      useSelector(adManagementSettingsSelectors.getFilterSettings),
      useSelector(adManagementSelectors.getTab),
    ];

  const dispatch = useDispatch();

  useEffect(() => {
    if (allowedScreen) {
      dispatch(masterDataActions.fetchAllForAdManagement());
    }
  }, [dispatch, allowedScreen]);

  return (
    <AdManagementCommonBar
      title={title}
      tooltip={tooltip}
      allowedScreen={allowedScreen}
      hasFilters={!isEmpty(filters)}
      mode={mode}
    />
  );
}

AdManagementCommonBarContainer.propTypes = {
  title: string,
  tooltip: shape({}),
  allowedScreen: bool,
};

AdManagementCommonBarContainer.defaultProps = {
  title: '広告管理',
  tooltip: {},
  allowedScreen: false,
};

export default AdManagementCommonBarContainer;
